export default class Collection{
    constructor(name,description,settingsId) {
        this.name =name;
        this.descriptions =description;
        this.settings = settingsId;
    }
}